// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c1a1ecd","455":"687ec4c2","977":"383b67c7"}[chunkId] + ".chunk.js";
};